import { z } from "zod";

import { post } from "@src/appV2/api/parsedApi";

const USER_LOGOUT_RESOURCE_TYPE = "user-logout";

const requestSchema = z.object({
  data: z.object({
    type: z.literal(USER_LOGOUT_RESOURCE_TYPE),
    attributes: z.object({ global: z.literal(true) }).strict(),
  }),
});

const responseSchema = z.object({
  data: z.object({
    type: z.literal(USER_LOGOUT_RESOURCE_TYPE),
    attributes: z.object({ revokedAt: z.string().datetime() }).strict(),
  }),
});

export async function logoutUserFromEverywhere(params: { userId: string }): Promise<void> {
  await post({
    url: `/auth/${params.userId}/logout`,
    data: {
      data: { type: USER_LOGOUT_RESOURCE_TYPE, attributes: { global: true } },
    },
    bodySchema: requestSchema,
    responseSchema,
  });
}
